export default {"src":"/_next/static/media/coupon-fill.75679e30.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};